export default () => ({
    restrict: 'E',
    template: "<div class='flipper' ng-transclude ng-class='{ flipped: flipped }'></div>",
    transclude: true,
    scope: {
        flipped: '=',
    },
});
